import script from "./EmbarquesMateriaisForm.vue?vue&type=script&setup=true&lang=js"
export * from "./EmbarquesMateriaisForm.vue?vue&type=script&setup=true&lang=js"

import "./EmbarquesMateriaisForm.vue?vue&type=style&index=0&id=01474a8d&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-01474a8d"]])

export default __exports__